<script lang="ts">
    import PanelistMeetingPage from '@Evaluation/AlternativesSurveys/Pages/PanelistMeetingPage'
    export default PanelistMeetingPage
</script>

<template>
    <div>
        <template v-if="viewTemplate === 'default'">
            <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
                <div class="container">
                    <a class="btn btn-light mr-auto" v-sanitizedHref="dashboardUrl">
                        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                        My Survey
                    </a>
                </div>
            </nav>
            <div class="container" style="padding-top: 80px;">
                <div id="MeetingQuestion">
                    <MeetingQuestionReview :propIsMeetingManager="false" :propRm="question"
                                           @update-vote-value="handleSavePanelistVoteCommand"
                                           @update-vote-comment="handleSavePanelistVoteCommentCommand" />
                </div>
            </div>
        </template>

        <template v-if="viewTemplate === 'connecting'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title"><i class="fa fa-spinner fa-spin"></i> Connecting...</h5>
                        <p class="card-text lead">We are checking if meeting was started by the host.</p><br />
                    </div>
                </div>
            </div>
        </template>

        <template v-if="viewTemplate === 'notStarted'">
            <div class="d-flex justify-content-center" style="padding-top: 200px;">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Meeting is not started</h5>
                        <p class="card-text lead">Please wait for the host to start this meeting.</p><br />
                        <a class="btn btn-secondary" v-sanitizedHref="dashboardUrl">Go to the survey</a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
